import React from "react";
import Modal from "react-modal";
import {Button, ModalHeader, ModalFooter} from 'react-bootstrap';

class ModalMessageNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmDeleteModal: false,
      showMainModal: false,
      deletingGroup: false,
      showSuccessAlert: false
    };
  }

  handleHideConfirmDeleteModal = () => {
    this.props.handleShowModal && this.props.handleShowModal(false);
  };

  handleConfirmDelete = () => {
    this.props.successButtonAction && this.props.successButtonAction();
  };

  render() {
    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '500px',
        width: '80%',
        maxHeight: '80vh',
        padding: '20px',
        boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
        borderRadius: '8px',
        backgroundColor: '#fff',
      }
    };

    return (
      <div className="modal-container" style={{height: 0.5}}>
        <Modal
          isOpen={this.props.showModal}
          onRequestClose={this.handleHideConfirmDeleteModal}
          contentLabel="Confirm Delete Modal"
          ariaHideApp={false}
          style={customStyles}
        >
          <ModalHeader style={styles.modalHeader}>
            <h1 style={styles.modalTitle}>{this.props.title}</h1>
          </ModalHeader>
          <ModalFooter style={styles.modalFooter}>
            <div style={styles.buttonContainer}>
              <Button style={styles.buttonSuccess}
                      onClick={this.handleHideConfirmDeleteModal}>
                Cancelar
              </Button>

              <Button variant="danger" style={styles.buttonError}
                      onClick={this.handleConfirmDelete}>
                Continuar
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const styles = {
  modalHeader: {
    borderBottom: '1px solid #ddd',
    paddingBottom: '10px',
    textAlign: 'center',
  },
  modalFooter: {
    borderTop: '1px solid #ddd',
    paddingTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  modalTitle: {
    fontSize: '1.4rem',
    marginBottom: '15px',
    textAlign: 'center',
    marginRight: '1px'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: '',
    alignItems: 'center',
  },
  buttonSuccess: {
    padding: '10px 30px',
    border: '2px solid #17a2b8',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#17a2b8',
    transition: 'background-color 0.3s ease',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    marginRight: '5px',

  },
  buttonError: {
    padding: '10px 30px',
    border: '2px solid #dc3545',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#dc3545',
    transition: 'background-color 0.3s ease',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    marginLeft: '5px',
  },
};

export default ModalMessageNew;



// WEBPACK FOOTER //
// ./src/component/Modal/ModalMessageNew.js